import { useWoody } from '../../woody/woody.js';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { integrationsQueryKeys } from '../queries/integrationsQueryKeys.js';

const useMutationMirrorRegistryUpdate = () => {
  const { client } = useWoody();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({ mirrorRegistryId, status }) => {
      return client.v2({
        endpoint: "/v2/mirror-registry/{mirrorRegistryId}",
        params: {
          mirrorRegistryId
        }
      }, {
        method: "patch",
        body: {
          status: status === "active" ? "active" : "paused"
        }
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: integrationsQueryKeys.list()
      });
    }
  });
  return mutation;
};

export { useMutationMirrorRegistryUpdate };
//# sourceMappingURL=useMutationMirrorRegistryUpdate.js.map
